import { render, staticRenderFns } from "./UserFieldEditDialog.vue?vue&type=template&id=0f4f2c6e&scoped=true&"
import script from "./UserFieldEditDialog.vue?vue&type=script&lang=js&"
export * from "./UserFieldEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserFieldEditDialog.vue?vue&type=style&index=0&id=0f4f2c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f2c6e",
  null
  
)

export default component.exports